import { render, staticRenderFns } from "./Anas.vue?vue&type=template&id=072d0d98&scoped=true"
import script from "./Anas.vue?vue&type=script&lang=js"
export * from "./Anas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d0d98",
  null
  
)

export default component.exports